import React from 'react';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';
import House from '@rover/icons/svg/house.svg';
import { Box, Flex, Heading, Text } from '@rover/kibble/core';
import IconBlock from '@rover/kibble/patterns/IconBlock';
import type { Behavior } from '@rover/rsdk/src/apiClient/latest/model/behavior';
import type { BehaviorCustom } from '@rover/rsdk/src/apiClient/latest/model/behaviorCustom';
import type { Skill } from '@rover/rsdk/src/apiClient/latest/model/skill';
import type { SkillCustom } from '@rover/rsdk/src/apiClient/latest/model/skillCustom';

interface WhatToExpectSectionProps {
  trainerInfo: {
    shortName: string;
    trainerProfile: {
      behaviors: Behavior[];
      behaviorsCustom: BehaviorCustom[];
      skills: Skill[];
      skillsCustom: SkillCustom[];
      details: {
        consultationDetails: string | null;
        sessionDetails: string;
      };
    };
  };
  isTrainerProfileReordering?: boolean;
}

const WhatToExpectSection: React.FC<WhatToExpectSectionProps> = ({
  trainerInfo,
  isTrainerProfileReordering = false,
}) => {
  // TODO (DEV-104195): Translate
  return (
    <>
      <Heading size="400" webProps={{ responsive: false }} mb="6x">
        {isTrainerProfileReordering ? 'What to expect' : 'More info'}
      </Heading>

      {trainerInfo.trainerProfile.details.consultationDetails && (
        <Flex flexDirection="column" py="0x">
          <OverflowTextModal
            textColor={isTrainerProfileReordering ? 'secondary' : 'primary'}
            numberOfLines={4}
            text={trainerInfo.trainerProfile.details.consultationDetails}
            fixedSizedContent={
              <Heading size="300" mb="4x" webProps={{ responsive: false }}>
                {isTrainerProfileReordering
                  ? 'Consultation'
                  : 'What to expect in your consultation'}
              </Heading>
            }
          />
        </Flex>
      )}

      <Flex flexDirection="column" pt="10x">
        <OverflowTextModal
          textColor={isTrainerProfileReordering ? 'secondary' : 'primary'}
          numberOfLines={4}
          text={trainerInfo.trainerProfile.details.sessionDetails}
          fixedSizedContent={
            <>
              <Heading size="300" mb="4x" webProps={{ responsive: false }}>
                {isTrainerProfileReordering ? 'Sessions' : 'Prepare for your first session'}
              </Heading>
              <Box py="2x" mb="4x">
                <IconBlock icon={House} iconSize="24px" iconMargin="2x" title="">
                  <Text textColor={isTrainerProfileReordering ? 'tertiary' : 'primary'}>
                    Typically in your home
                  </Text>
                </IconBlock>
              </Box>
            </>
          }
        />
      </Flex>
    </>
  );
};
export default WhatToExpectSection;
